export const FLASHSALE_TIMER_SETED = 'flashsale-timer-seted';